export const EntityListPageStateKey = 'EntityListPageStates';

export interface EntityListPageStateInfo {
  expanded_entity_ids: string[];
}

export interface EntityListPageStates {
  [url: string]: EntityListPageStateInfo;
}

export const initialState: EntityListPageStates = {
};
